export const inventorySuggestions=['냉장고','세탁기','침대','소파','책상','박스'];
